function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Messages = function () {
  function Messages(msgData, defaultLocale) {
    var _this = this;

    this._data = {};
    this._fallback = {};
    Object.keys(msgData).forEach(function (lc) {
      if (lc !== 'toString') {
        _this._data[lc] = msgData[lc];
        if (defaultLocale === undefined) defaultLocale = lc;
      }
    });
    this.locale = defaultLocale;
    this._defaultLocale = this.locale;
  }

  var _proto = Messages.prototype;

  _proto.addMessages = function addMessages(data, lc, keypath) {
    if (!lc) lc = this.locale;

    if (typeof data !== 'function') {
      data = Object.keys(data).reduce(function (map, key) {
        if (key !== 'toString') map[key] = data[key];
        return map;
      }, {});
    }

    if (Array.isArray(keypath) && keypath.length > 0) {
      var parent = this._data[lc];

      for (var i = 0; i < keypath.length - 1; ++i) {
        var key = keypath[i];
        if (!parent[key]) parent[key] = {};
        parent = parent[key];
      }

      parent[keypath[keypath.length - 1]] = data;
    } else {
      this._data[lc] = data;
    }

    return this;
  };

  _proto.resolveLocale = function resolveLocale(lc) {
    if (this._data[lc]) return lc;

    if (lc) {
      var l = String(lc);

      while (l = l.replace(/[-_]?[^-_]*$/, '')) {
        if (this._data[l]) return l;
      }

      var ll = this.availableLocales;
      var re = new RegExp('^' + lc + '[-_]');

      for (var i = 0; i < ll.length; ++i) {
        if (re.test(ll[i])) return ll[i];
      }
    }

    return null;
  };

  _proto.getFallback = function getFallback(lc) {
    if (!lc) lc = this.locale;
    return this._fallback[lc] || (lc === this.defaultLocale || !this.defaultLocale ? [] : [this.defaultLocale]);
  };

  _proto.setFallback = function setFallback(lc, fallback) {
    this._fallback[lc] = Array.isArray(fallback) ? fallback : null;
    return this;
  };

  _proto.hasMessage = function hasMessage(key, lc, fallback) {
    if (!lc) lc = this.locale;
    var fb = fallback ? this.getFallback(lc) : null;
    return _has(this._data, lc, key, fb, 'function');
  };

  _proto.hasObject = function hasObject(key, lc, fallback) {
    if (!lc) lc = this.locale;
    var fb = fallback ? this.getFallback(lc) : null;
    return _has(this._data, lc, key, fb, 'object');
  };

  _proto.get = function get(key, props, lc) {
    if (!lc) lc = this.locale;

    var msg = _get(this._data[lc], key);

    if (msg) return typeof msg == 'function' ? msg(props) : msg;
    var fb = this.getFallback(lc);

    for (var i = 0; i < fb.length; ++i) {
      msg = _get(this._data[fb[i]], key);
      if (msg) return typeof msg == 'function' ? msg(props) : msg;
    }

    return key;
  };

  _createClass(Messages, [{
    key: "availableLocales",
    get: function get() {
      return Object.keys(this._data);
    }
  }, {
    key: "locale",
    get: function get() {
      return this._locale;
    },
    set: function set(lc) {
      this._locale = this.resolveLocale(lc);
    }
  }, {
    key: "defaultLocale",
    get: function get() {
      return this._defaultLocale;
    },
    set: function set(lc) {
      this._defaultLocale = this.resolveLocale(lc);
    }
  }]);

  return Messages;
}();

export { Messages as default };

function _get(obj, key) {
  if (!obj) return null;

  if (Array.isArray(key)) {
    for (var i = 0; i < key.length; ++i) {
      obj = obj[key[i]];
      if (!obj) return null;
    }

    return obj;
  }

  return obj[key];
}

function _has(data, lc, key, fallback, type) {
  var msg = _get(data[lc], key);

  if (msg) return typeof msg === type;

  if (fallback) {
    for (var i = 0; i < fallback.length; ++i) {
      msg = _get(data[fallback[i]], key);
      if (msg) return typeof msg === type;
    }
  }

  return false;
}